import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ViewChild } from '@angular/core';

import { Reserva, ReservaData } from '@app/_models/reserva';
import { ReservasService } from '@app/services/reservas.service';
import { SessionService } from '@app/services/session.service';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FieldCapacity } from '@app/_models/facilities';
import { eReservetype } from '@app/_enums/reserve-type';
import { PaymentsService } from '@app/services/payments/payments.service';
import { PaymentVariable } from '@app/_models/payments';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-reserva-modal',
  templateUrl: './reserva-modal.component.html',
  styleUrls: ['./reserva-modal.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  ]
})

export class ReservaModalComponent implements OnInit {

  reserva: Reserva;
  openShifts: any = ['17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];
  openShiftsFin: any = ['18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'];
  openShiftsWeekend: any = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];
  fieldSizes: FieldCapacity[];
  f_date = new FormControl(moment());
  f_date_fin = new FormControl(moment());
  f_turno: string;
  f_turno_fin: string;
  minDate: Date;
  selectedType: number;
  isUpdate: boolean = false;
  typeOptions: { name: string; value: number }[] = [];
  changeDate: boolean = false;
  isEndTimeInvalid: boolean = false;
  isTypeReserveInvalid: boolean = false;
  clickButton: boolean = false;
  paymentActive: boolean = false;
  paymentActiveSelect: boolean | null = false;
  paymentVariable: PaymentVariable;

  @ViewChild('f', { static: false }) form: NgForm;

  onAdd = new EventEmitter();

  constructor(
    public modalRef: MatDialogRef<ReservaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReservaData,
    private reservasService: ReservasService,
    private session: SessionService,
    private _snackBar: MatSnackBar,
    private paymentsService: PaymentsService
  ) {
    this.reserva = data.reserva
    this.isUpdate = data.updateReserva;
    this.selectedType = eReservetype.Partidos;

    if (data.updateReserva) {
      this.setHoursRerserve()
      this.selectedType = Number(this.reserva.reservation_type);
    }

    for (const key in eReservetype) {
      if (isNaN(Number(key))) {
        if (Number(eReservetype[key]) != 2) {
          this.typeOptions.push({ name: key, value: Number(eReservetype[key]) });
        }
      }
    }

  }

  ngOnInit() {
    if (this.f_date) {
      this.minDate = new Date();
      this.fieldSizes = this.session.field_sizes;
      this.f_date = new FormControl(moment(this.reservasService.getSharedCourrencyDay()));
      this.f_date_fin = new FormControl(moment(this.reservasService.getSharedCourrencyDay()));
    }

    this.updateOpenSiftForDay(this.reservasService.getSharedCourrencyDay())

    this.isTypeReserveInvalid = this.selectedType == 1;
    if (this.reserva.payment_variable) {
      this.selectedType = Number(this.reserva.reservation_type);
      this.paymentVariable = this.reserva.payment_variable;
      this.paymentActive = true;
    }

    this.paymentActiveSelect = this.reserva.payment_variable !== null;

    this.reserva.payway_payment = null;
  }


  setHoursRerserve() {
    const start_timeString = this.data.reserva.start_time;
    const start_time = new Date(start_timeString);
    const end_timeString = new Date(this.data.reserva.end_time);
    const end_time = new Date(end_timeString);

    if (!isNaN(start_time.getTime())) {
      const hora = start_time.getHours();
      this.f_turno = hora.toString() + ':00';
      this.f_turno_fin = end_time.getHours().toString() + ':00';
    }
  }

  onNoClick(): void {
    this.modalRef.close();
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    const dateDay = event.value.toString()
    this.f_date.value.set({
      date: (new Date(dateDay)).getDate(),
    });
    this.f_date_fin.value.set({
      date: (new Date(dateDay)).getDate(),
    });

    this.updateOpenSiftForDay(event.value);
    this.onHourSelect()
    this.onHourSelectFin()
  }

  updateOpenSiftForDay(selectedDate: any) {
    const selectedDayOfWeek = new Date(selectedDate.toString()).getDay();

    if (selectedDayOfWeek === 0 || selectedDayOfWeek === 6) {
      this.openShifts = [...this.openShiftsWeekend, ...this.openShifts];
      this.openShiftsFin = [...this.openShiftsWeekend, ...this.openShiftsFin]
    } else {
      this.openShifts = ['17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];
      this.openShiftsFin = ['18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'];
    }
  }

  onHourSelect() {
    if (this.f_date.value) {
      this.f_date.value.set({
        hour: parseInt(this.f_turno.slice(0, 2)),
        minute: parseInt(this.f_turno.slice(3, 5)),
        second: 0
      });
    }

    if (Number(this.selectedType) === eReservetype.Partidos) {
      const hourInicio = parseInt(this.f_turno.slice(0, 2));
      const minuteInicio = parseInt(this.f_turno.slice(3, 5));

      this.f_date_fin.value.set({
        hour: hourInicio + 1,
        minute: minuteInicio,
        second: 0
      });

      const hourFin = this.f_date_fin.value.hour();
      this.f_turno_fin = `${hourFin.toString().padStart(2, '0')}:${minuteInicio.toString().padStart(2, '0')}`;
    }

    this.validateTime();
    this.changeDate = true;
  }

  onHourSelectFin() {
    let hours = parseInt(this.f_turno_fin.slice(0, 2))
    let minutes = parseInt(this.f_turno_fin.slice(3, 5))

    if (this.f_date_fin.value) {
      this.f_date_fin.value.set({
        date: new Date(this.f_date.value.toString()).getDate(),
        year: new Date(this.f_date.value.toString()).getFullYear(),
        month: new Date(this.f_date.value.toString()).getMonth(),
      })

      this.f_date_fin.value.set({
        hour: hours,
        minute: minutes,
        second: 0,
      });
    }

    this.validateTime();
    this.changeDate = true;
  }

  validateTime() {
    if (this.f_turno && this.f_turno_fin) {
      const startTime = new Date(0);
      const endTime = new Date(0);

      if (typeof this.f_turno === 'string' && typeof this.f_turno_fin === 'string') {
        startTime.setHours(parseInt(this.f_turno.slice(0, 2)));
        startTime.setMinutes(parseInt(this.f_turno.slice(3, 5)));
        endTime.setHours(parseInt(this.f_turno_fin.slice(0, 2)));
        endTime.setMinutes(parseInt(this.f_turno_fin.slice(3, 5)));

        if (endTime <= startTime && this.selectedType != eReservetype.Partidos && endTime.getHours() != 0) {
          this.isEndTimeInvalid = true;
        } else {
          this.isEndTimeInvalid = false;
        }
      }
    }

    this.validateTypeReserve(this.selectedType);
  }

  validateTypeReserve(value: any) {
    const typeReserve = value == null ? this.reserva.reservation_type : value;
    if (typeReserve == eReservetype.Partidos) {
      this.isTypeReserveInvalid = true;
    } else {
      this.isTypeReserveInvalid = false;
    }
  }

  calculateTimeDifference(): number {
    const startTime = new Date(0);
    const endTime = new Date(0);

    startTime.setHours(parseInt(this.f_turno.slice(0, 2)));
    startTime.setMinutes(parseInt(this.f_turno.slice(3, 5)));
    endTime.setHours(parseInt(this.f_turno_fin.slice(0, 2)));
    endTime.setMinutes(parseInt(this.f_turno_fin.slice(3, 5)));

    return endTime.getHours() - startTime.getHours();
  }

  onSubmit() {
    this.reserva.facility = this.session.currentFacility.id;
    this.reserva.reservation_type = this.selectedType;
    this.reserva.payway_payment = this.paymentActiveSelect ? this.paymentVariable.id : null;
    this.reserva.payment_variable = this.reserva.payway_payment == null ? null : this.reserva.payway_payment;

    this.clickButton = true;

    if (this.isUpdate) {
      this.reserva.end_time = new Date(this.reserva.start_time);

      this.onHourSelect()
      this.reserva.start_time = this.f_date.value.toDate();
      this.onHourSelectFin()
      this.reserva.end_time = this.f_date_fin.value.toDate();

      if (this.reserva.reservation_type === eReservetype.Partidos) {
        this.reserva.end_time = new Date(this.reserva.start_time);
        this.reserva.end_time.setHours(this.reserva.start_time.getHours() + 1);
      }

      this.reservasService.updateReserva(this.reserva)
        .subscribe(
          data => {
            this.openSnackBar("Reserva actualizada!");
            this.reservasService.notificarRecargaModReservas();
            this.modalRef.close(this.f_date.value.toDate());
            this.clickButton = false;
          },
          (error) => {
            this.openSnackBar('Oops! El turno solicitado ya no está disponible. Por favor intente nuevamente.');
            console.log(error);
            this.clickButton = false;
          }
        );

    } else {
      this.reserva.start_time = this.f_date.value.toDate();
      this.reserva.end_time = this.f_date_fin.value.toDate();

      if (this.reserva.reservation_type === eReservetype.Partidos) {
        this.reserva.end_time = new Date(this.reserva.start_time);
        this.reserva.end_time.setHours(this.reserva.start_time.getHours() + 1);
      }

      this.reservasService.add(this.reserva)
        .subscribe(
          data => {
            this.openSnackBar("Reserva creada!");
            this.modalRef.close(this.f_date.value.toDate());
            this.clickButton = false;

          },
          (error) => {
            this.clickButton = false;
            this.openSnackBar('Oops! El turno solicitado ya no está disponible. Por favor intente nuevamente.');
            console.log(error);
          }
        );
    }
  }

  changeCapacity(event: any) {
    this.paymentsService.getPaymentVariable(this.selectedType, this.reserva.field_capacity)
      .subscribe(data => {
        this.paymentVariable = data;
      }, (error) => {
        console.log(error);
      })
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "", {
      duration: 2000
    });
  }

  formatTypeReservation(name: string) {
    return name.replace(/_/g, ' ');
  }

  validateSenaReserve() {
    this.paymentActive = this.paymentActiveSelect;
  }
}
